import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBook } = FiIcons;

export default function BookCard({ book }) {
  const [imgError, setImgError] = useState(false);
  const { title, author, image, affiliateUrl } = book;

  return (
    <li className="bg-white rounded-[20px] p-6 sm:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.02)] border border-[#F0EFEA] flex flex-col h-full snap-start shrink-0 w-full md:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)]">
      {/* Decorative Line */}
      <div className="w-8 h-[2px] bg-soft-gold mb-5 mx-auto rounded-full" />

      {/* Title Area */}
      <div className="flex-grow-0 mb-6 flex flex-col justify-end min-h-[80px]">
        <h3 className="text-xl text-primary-green font-serif text-center font-medium leading-tight line-clamp-3">
          {title}
        </h3>
      </div>

      {/* Cover Image Area */}
      <a
        href={affiliateUrl}
        target="_blank"
        rel="sponsored noopener noreferrer"
        aria-label={`Buy ${title} on Amazon`}
        className="block mb-6 relative group focus:outline-none focus:ring-2 focus:ring-soft-gold focus:ring-offset-2 rounded-md"
      >
        <div className="w-full aspect-[2/3] relative overflow-hidden bg-warm-cream rounded-sm flex items-center justify-center transition-transform duration-300 group-hover:-translate-y-1 group-hover:shadow-md">
          {imgError || !image ? (
            <div className="flex flex-col items-center justify-center text-primary-green opacity-40 p-4 text-center">
              <SafeIcon icon={FiBook} className="text-4xl mb-3" />
              <span className="text-sm font-medium tracking-wide">Cover Unavailable</span>
            </div>
          ) : (
            <img
              src={image}
              alt={`${title} by ${author} book cover`}
              className="w-full h-full object-contain"
              onError={() => setImgError(true)}
              loading="lazy"
              width="400"
              height="600"
            />
          )}
        </div>
      </a>

      {/* Author & Actions Area */}
      <div className="mt-auto flex flex-col items-center">
        <p className="text-forest-green text-center text-base mb-6">
          By <span className="font-medium">{author}</span>
        </p>

        <a
          href={affiliateUrl}
          target="_blank"
          rel="sponsored noopener noreferrer"
          aria-label={`View ${title} by ${author} on Amazon`}
          className="bg-primary-green text-white hover:bg-forest-green focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-soft-gold rounded-[16px] px-6 py-3.5 block text-center transition-colors duration-200 font-medium text-[15px] w-full"
        >
          View Book on Amazon
        </a>

        <p className="text-xs text-gray-400 text-center mt-3 tracking-wide">
          Affiliate link
        </p>
      </div>
    </li>
  );
}